import React, {useMemo, useState, useEffect, useCallback, useContext} from "react";
import {useLocation, useParams} from "react-router-dom";
import {connect} from "react-redux";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";

import SearchBox from "../../../components/SearchBox/SearchBox";
import PopOver from "../../../components/Popover/Popover";
import {SearchContext} from "../../../contexts/search/search.context";
import {AuthContext} from "../../../contexts/auth/auth.context";
import {useStoreLogo} from "../../../contexts/store-logo/use-storeLogo";
import AuthenticationForm from "../../SignInOutForm/Form";
import {RightMenu} from "./Menu/RightMenu/RightMenu";
import { LeftMenu } from "./Menu/LeftMenu/LeftMenu";
import NavMenu from "./Menu/NavMenu/NavMenu";
import HeaderWrapper, {LanguageList, WelcomeText} from "./Header.style";
import UserImage from "../../../image/user.jpg";
import {isCategoryPage} from "../is-home-page";
import {useSEO} from "../../../hooks/useSEO";

import {
  searchSuggestions,
  searchStoreProduct,
  Reset_Suggestions,
  Toggle_Suggestions,
  getProductOutOfStock,
  getProductOutOfStockCat,
  getProductsMappedwithSubCat,
  getProductBrands,
  getProductsMappedwithCat,
  changePage,
	resetPage, sortProducts,
  SearchStoreProductByBrandRef,
  getProductFilterBrands
} from "../../../store/actions/productAction";
import {
  changeNotificationPage,
  resetNotificationPage,
  getAllNotifications,
  getCountUnreadNotifications,
  markAllAsRead
} from '../../../store/actions/notificationAction'
import {
  initExpressStoreProducts,
} from "../../../store/actions/expressAction";

import {
  resetAuthState,
} from "../../../store/actions/authAction";
import enFlagIcon from "../../../assets/icons/united-kingdom.svg";
import kmFlagIcon from "../../../assets/icons/cambodia.svg";
import { getActivePromotionCampaign, minusHour, resetActivePromotionCampaign } from "../../../store/actions/promotionCampaignAction";
import { CampaignDescriptions } from "../../SalePromotionCampaign/SaleCampaign.style";
import SaleCampaignTimer from "../../SalePromotionCampaign/CampaignTimer";
import t from "../../../i18n/translate";
import { logEventPromotionClick, logSearchQuery } from "../../../services/googleAnalytics";
import { getPartnerPages } from "../../../store/actions/globalAction";

const useRouter = () => {
  const location = useLocation();
  const params = useParams();
  return useMemo(() => {
    return {
      pathname: location.pathname,
      location,
      query: {
        ...params,
      },
    };
  }, [params, location]);
};
const Header = (props, {className}) => {
  const { storeLogo, fetchStoreLogo } = useStoreLogo();
	const {authState: {isAuthenticated}, authDispatch} = useContext(AuthContext);
	const {state, searchdispatch} = useContext(SearchContext);
  const router = useRouter();
  const [text, setText] = useState("");
  const [show, setShow] = useState(false);

	const mql = useMemo(() => window.matchMedia("all and (min-width: 769px)"), []);
	const sug_sub_cat_id = useMemo(() => localStorage.getItem("sug_sub_cat_id"), []);

	// Use SEO hook for meta tags management
	useSEO();

  useEffect(() => {
    if (isAuthenticated) {
      setShow(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (text !== "" && text.length >= 3) {
        searchdispatch({
          type: "UPDATE",
          payload: {
            text: text.replace(/[!@#$%^&*/']/g, " "),
          },
        });
      }
    }, 0);
    return () => clearTimeout(timeout);
  }, [text, searchdispatch]);

  useEffect(() => {
	  if (window.location.pathname.split('/').includes("search")) {
		  const encodedQuery = window.location.pathname.split('/')[2];
		  // Decode URL-encoded characters (e.g., %20 -> space)
		  let decodedQuery = encodedQuery;
		  try {
			  decodedQuery = decodeURIComponent(encodedQuery);
		  } catch (e) {
			  decodedQuery = encodedQuery;
		  }
		  localStorage.setItem("search_query", decodedQuery);
		  setText(decodedQuery);
    }
  }, []);
  useEffect(() => {
      if (sug_sub_cat_id) return;
      if (
        props.all_suggested_subcats &&
        props.all_suggested_subcats[0]
      ) {
        searchdispatch({
          type: "SUGGESTION",
          payload: {
            suggestion: props.all_suggested_subcats[0].sub_cat_id,
          },
        });
        if (sug_sub_cat_id) return;    }
  }, [props.all_suggested_subcats, searchdispatch, sug_sub_cat_id]);

	const {pathname} = router;

	const handleLogout = useCallback(() => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("supplier");
      localStorage.setItem("order_id", 0);
	    authDispatch({type: "SIGN_OUT"});
      window.location.href = "/";
    }
	}, [authDispatch]);

	const handleJoin = useCallback(() => {
		window.trigger = "my profile";
		authDispatch({type: "SIGNIN"});
    setShow(true);
	}, [authDispatch]);

	const onSearch = useCallback((text) => {
		setText(text);
    if (props.all_suggested_subcats.length !== 0) {
      props.Reset_Suggestions();
    }
	}, [props]);

	const onClickHandler = useCallback(async () => {
		logSearchQuery(text);
		localStorage.setItem("search_query", text);

		if (text !== "" && text.length >= 3) {
      localStorage.setItem("sub_cat_id", -1);
      localStorage.setItem("subcatname", "");
			window.location.href = `/search/${encodeURIComponent(text.trim())}`;
			await props.searchSuggestions({search_query: text, store_id: 1});

      if (props.page === 1) {
	      props.Toggle_Suggestions({toggle: true});
      }
    }

		const sidebarBlock = document.querySelector("#sidebarBlock");
		if (sidebarBlock) {
			const topOfElement = sidebarBlock.offsetTop - 90;
			window.scrollTo({top: topOfElement, behavior: "smooth"});
    }

		if (pathname.includes("search")) {
			const searchBox = document.querySelector(".SearchBox");
			if (searchBox) {
				searchBox.blur();
			}
			props.Toggle_Suggestions({toggle: false});
    }
	}, [text, props, pathname]);

	const showSearch = useMemo(() =>
    isCategoryPage(pathname) &&
    window.location.pathname.split("/").length > 1 &&
			window.location.pathname.split("/").length <= 4 &&
			window.location.pathname.indexOf("not-found") === -1,
		[pathname]
	);

	const onChangeLanguage = useCallback((lang) => {
		if (localStorage.getItem("lang") !== lang) {
			localStorage.setItem("lang", lang);
      window.location.reload();
    }
	}, []);

	const handleHide = useCallback(() => {
    setShow(false);
    props.resetAuthState();
	}, [props]);

  useEffect(() => {
    props.getActivePromotionCampaign();
	  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

	const checkCampaignAvailable = useCallback(() => {
		if (!props.active_campaign) return false;

		const displayAhead = new Date(
      minusHour(props.active_campaign?.sale_promotion_campaign_product?.display_ahead, 7)
    )?.getTime();

		const startDate = new Date(
      minusHour(props.active_campaign?.sale_promotion_campaign_product?.start_date, 7)
    )?.getTime();

		const now = new Date().getTime();

		return now > displayAhead && startDate < now;
	}, [props.active_campaign]);

  useEffect(() => {
    fetchStoreLogo();
  }, [fetchStoreLogo]);

	const currentLang = useMemo(() => localStorage.getItem("lang") || "en", []);
	const isExpressRoute = useMemo(() => window.location.pathname.includes("express"), []);

	const languageIcon = useMemo(() =>
			currentLang === "km" ? kmFlagIcon : enFlagIcon,
		[currentLang]
	);

	const languageAlt = useMemo(() =>
			currentLang === "km" ? "Khmer Language" : "English Language",
		[currentLang]
	);

	const excludedRoutes = useMemo(() =>
			["/profile", "/checkout", "/all-orders"],
		[]
	);

	const isExcludedRoute = useMemo(() =>
			excludedRoutes.some((route) => window.location.pathname.includes(route)),
		[excludedRoutes]
	);

	const shouldShowSearch = showSearch || isExpressRoute || isExcludedRoute;

	const shouldShowNavMenu = useMemo(() =>
			props.cartType !== "express" && !isExcludedRoute,
		[props.cartType, isExcludedRoute]
	);

	const shouldShowCampaignBanner = useMemo(() =>
			checkCampaignAvailable() &&
			mql.matches &&
			!window.location.pathname.includes("/campaign") &&
			!isExcludedRoute,
		[checkCampaignAvailable, mql, isExcludedRoute]
	);

	const campaignBannerStyle = useMemo(() => ({
		position: "relative",
		top: window.matchMedia("all and (min-width: 990px)").matches ? "100px" : "55px",
		zIndex: "-1",
		padding: "0.25rem",
		boxShadow: "rgba(17, 17, 26, 0.1) 0px 1px 0px",
	}), []);

	const handleCampaignClick = useCallback(() => {
		logEventPromotionClick(props.active_campaign?.campaign_id);
		window.location.href = `/campaign/${props.active_campaign?.campaign_id}`;
	}, [props.active_campaign?.campaign_id]);

  return (
    <>
	    <HeaderWrapper className={className}>
		    <LeftMenu props={props} logo={storeLogo}/>
		    {shouldShowSearch && (
			    <>
				    <SearchBox
					    className="headerSearch"
					    suggestions={props.all_suggested_subcats}
					    handleSearch={onSearch}
					    onClick={onClickHandler}
					    placeholder="Search anything..."
					    hideType={true}
					    minimal={true}
					    showSvg={false}
					    props={props}
					    value={text}
            />
				    <WelcomeText>10% off on your first purchase now!</WelcomeText>
			    </>
		    )}
		    <div className="user-action">
          <LanguageList>
            <PopOver
              direction="right"
              className="user-pages-dropdown"
              handler={
                <ul className="language-list">
	                <li className={currentLang}>
		                <Image src={languageIcon} alt={languageAlt}/>
	                </li>
                </ul>
              }
              content={
                <div className="popUpContainer">
	                <div className="popUpItem" onClick={() => onChangeLanguage("en")}>
                    <div className="flag en">
                      <Image src={enFlagIcon} alt="English Language" />
                    </div>
		                English
                  </div>
	                <div className="popUpItem" onClick={() => onChangeLanguage("km")}>
                    <div className="flag km">
                      <Image src={kmFlagIcon} alt="Khmer Language" />
                    </div>
                    ខ្មែរ
                  </div>
                </div>
              }
            />
          </LanguageList>
        <RightMenu
          props={props}
          isAuthenticated={isAuthenticated}
          onJoin={handleJoin}
          onLogout={handleLogout}
          avatar={UserImage}
        />
      </div>

      <Modal
        show={show}
        onHide={handleHide}
        dialogClassName="modal-90w authModal"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton style={{border: 0}}></Modal.Header>
        <Modal.Body style={{padding: 0}}>
          <AuthenticationForm/>
        </Modal.Body>
      </Modal>
	    </HeaderWrapper>

	    {shouldShowNavMenu && <NavMenu props={props}/>}

	    {shouldShowCampaignBanner && (
		    <CampaignDescriptions
			    style={campaignBannerStyle}
			    onClick={handleCampaignClick}
		    >
			    <img
				    src={props.active_campaign?.icon}
				    alt={props.active_campaign?.name}
				    loading="lazy"
				    className="campaign-logo"
			    />
			    <div className="count-down-content">
				    <p className="campaign-promotion-end-in-label">
					    {t("promotion_campaign_ends_in_title")}
				    </p>
				    <SaleCampaignTimer
					    campaign={props.active_campaign}
					    resetCampaign={props.resetActivePromotionCampaign}
				    />
			    </div>
		    </CampaignDescriptions>
	    )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    success: state,
    storeSelected: state.expressReducer.storeSelected,
    suggested_subcats: state.productReducer.suggested_subcats,
    allproducts: state.productReducer.allproducts,
    all_suggested_subcats: state.productReducer.all_suggested_subcats,
    modalData: state.productReducer.modalData,
    togglesuggestion: state.productReducer.togglesuggestion,
    filteredProducts: state.productReducer.filteredProducts,
    page: state.productReducer.page,
    min: state.productReducer.min,
    max: state.productReducer.max,
    sort: state.productReducer.sort,
    priority: state.productReducer.priority,
    promotion: state.productReducer.promotion,
    p_oos: state.productReducer.oos,
    brand_id:state.productReducer.brand_id,
    cat_id: state.productReducer.cat_id,
    cat_id_18: state.productReducer.cat_id_18,
	  sub_cat_id: state.productReducer.sub_cat_id,
	  diet_id: state.productReducer.diet_id,
    sub_cat_18: state.productReducer.sub_cat_18,
    country_id: state.productReducer.country_id, 
    cat_refs: state.productReducer.cat_refs,
    oos: state.globalReducer.oos,
	  category: state.productReducer.category,
	  dietary: state.productReducer.dietary,
    type: state.productReducer.type,
    cartType: state.cartReducer.cartType,
    brands: state.productReducer.brands,
    notifications: state.notificationReducer.notifications,
    notification_page: state.notificationReducer.page,
    notifcation_loading: state.notificationReducer.loading,
    unread_notification: state.notificationReducer.unread_notification,
    has_more: state.notificationReducer.has_more,
    active_campaign: state.promotionCampaignReducer.active_campaign,
    filterBrands: state.productReducer.filterBrands,
    suggestionItems: state.productReducer.suggestionItems,
    suggestion_loading: state.productReducer.suggestion_loading,
    all_pages: state.globalReducer.all_pages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchSuggestions: (data) => searchSuggestions(data, dispatch),
    searchStoreProduct: (data) => searchStoreProduct(data, dispatch),
    Reset_Suggestions: () => Reset_Suggestions(dispatch),
    Toggle_Suggestions: (body) => Toggle_Suggestions(body, dispatch),
    changePage: (body) => changePage(body, dispatch),
    resetPage: () => resetPage(dispatch),
    getProductsMappedwithSubCat: (data) => getProductsMappedwithSubCat(data, dispatch),
    getProductsMappedwithCat: (data) => getProductsMappedwithCat(data, dispatch),
    getProductOutOfStock: (body) => getProductOutOfStock(body, dispatch),
    getProductOutOfStockCat: (body) => getProductOutOfStockCat(body, dispatch),
    initProductExpressStore: (data) => initExpressStoreProducts(data, dispatch),
    sortProducts: (data) => sortProducts(data, dispatch),
    getProductBrands: () => getProductBrands(dispatch),
    resetAuthState: () => resetAuthState(dispatch),
    getAllNotifications: (data) => getAllNotifications(data, dispatch),
    getCountUnreadNotifications: () => getCountUnreadNotifications(dispatch),
    markAllAsRead: () => markAllAsRead(dispatch),
    changeNotificationPage: (data) => changeNotificationPage(data, dispatch),
    resetNotificationPage: () => resetNotificationPage(dispatch),
    getActivePromotionCampaign: () => getActivePromotionCampaign(dispatch),
    resetActivePromotionCampaign: () => resetActivePromotionCampaign(dispatch),
    getPartnerPages: (body) => getPartnerPages(body,dispatch),
    SearchStoreProductByBrandRef: (data) => SearchStoreProductByBrandRef(data, dispatch),
    getProductFilterBrands: (body, products, allproducts, sub_cat_id, cat_id, brandName, oos, text) =>
      getProductFilterBrands(body, products, allproducts, sub_cat_id, cat_id, brandName, oos, text, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
